angular.module('workflow.app')
  .filter 'urlDisplayGoogle', () ->
    return ( aUrl ) ->
      iMaxChars = 76

      if aUrl.length? and aUrl.length > iMaxChars
        iEndChars   = 20

        iStartChars = iMaxChars - 3 - iEndChars
        iEnd   = aUrl.slice( -iEndChars )
        iStart = aUrl.slice( 0, iStartChars )
        return iStart + '...' + iEnd
      else
        return aUrl
